<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import "components/vendor/bootstrap/css/bootstrap.min.css";
  @import "components/vendor/font-awesome/css/font-awesome.min.css";
  @import "https://fonts.googleapis.com/css?family=Roboto:300,400,700";
  @import "components/vendor/bootstrap-select/css/bootstrap-select.min.css";
  @import "components/vendor/owl.carousel/assets/owl.carousel.css";
  @import "components/vendor/owl.carousel/assets/owl.theme.default.css";
  @import "components/css/style.default.css";
  body{
    margin:0;
    padding:0;
  }
#app {
}

  .logos {
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue